// extracted by mini-css-extract-plugin
export default {"Paragraph":"Paragraph_Paragraph__C5utG","Loading":"Paragraph_Loading__AuJ+R","First":"Paragraph_First__5Dp1r","load":"Paragraph_load__p9Y0v"};